var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_852",
    "data-name": "Group 852",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17.71,
    viewBox: "0 0 23 17.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M.851,16.06h3.5a4.268,4.268,0,0,0,8.349,0h9.453a.851.851,0,1,0,0-1.7H12.7a4.271,4.271,0,0,0-8.349.023H.851A.849.849,0,0,0,0,15.232.83.83,0,0,0,.851,16.06ZM8.51,12.679a2.53,2.53,0,1,1-2.553,2.53A2.542,2.542,0,0,1,8.51,12.679Z",
    transform: "translate(0 -11)",
    fill: "#536dfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M22.149,54.681h-3.5a4.268,4.268,0,0,0-8.349,0H.851A.849.849,0,0,0,0,55.532a.864.864,0,0,0,.851.851H10.3a4.271,4.271,0,0,0,8.349-.023h3.5a.84.84,0,1,0,0-1.679ZM14.49,58.062a2.53,2.53,0,1,1,2.553-2.53A2.542,2.542,0,0,1,14.49,58.062Z",
    transform: "translate(0 -42.031)",
    fill: "#536dfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.460ad7c8.svg";
export { ForwardRef as ReactComponent };